import axios, { AxiosResponse } from "axios"
import { guid } from "@/service/utils/useful"
import { server } from "@/service/constant.json"

export function serverURL() {
  return process.env.NODE_ENV === "production" ? server.live : server.dev
}

export function httpDataForm(CmdType: String, CarNum: String): object {
  return {
    Header: {
      CmdType: CmdType,
      CallApp: "AIRS",
      TransactionID: guid(),
    },
    Body: {
      CarNum: CarNum,
    },
  }
}

export function WSSActionPopup(val: string, callback: Function) {
  // @ts-ignore
  return CQWebVoiceHelper.CQActionPopup(val, callback)
}

export function WSSActionCode(val: string, useWait: Boolean) {
  // @ts-ignore
  return useWait ? CQWebVoiceHelper.CQActionCODE(val) : CQWebVoiceHelper.CQActionCODE(val, { useWait: false })
}

export function requestServer(httpData: object): Promise<AxiosResponse<string, object>> {
  return axios.post(serverURL(), JSON.stringify(httpData))
}
